<app-text-input
  class="full-width"
  [placeholder]="placeholder"
  [control]="control"
  [form]="form"
  showPlaceholder="false"
  uppercase="true"
></app-text-input>
